import { jsx as ___EmotionJSX } from "@emotion/core";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import { hiddenOffScreen, ellipsis } from "../css";
import SegmentCheckIcon from "./SegmentCheckIcon";
import SegmentContainer from "./SegmentContainer";

var Segment = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Segment, _React$Component);

  function Segment() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Segment.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        id = _this$props.id,
        name = _this$props.name,
        index = _this$props.index,
        item = _this$props.item,
        selectedItem = _this$props.selectedItem,
        toLabel = _this$props.toLabel,
        toValue = _this$props.toValue,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur,
        disabled = _this$props.disabled,
        focused = _this$props.focused;
    var checked = selectedItem != null && toValue(selectedItem) === toValue(item);
    var inputId = id || name;

    if (index > 0) {
      inputId = inputId + "-" + index;
    }

    return ___EmotionJSX(SegmentContainer, {
      disabled: disabled,
      focused: focused,
      checked: checked
    }, ___EmotionJSX("input", {
      css: hiddenOffScreen,
      type: "radio",
      id: inputId,
      name: name,
      checked: checked,
      value: toValue(item),
      onChange: onChange && function () {
        return onChange(item);
      },
      onFocus: onFocus,
      onBlur: onBlur,
      disabled: disabled
    }), checked && ___EmotionJSX(SegmentCheckIcon, {
      size: 16
    }), ___EmotionJSX("div", {
      css: ellipsis
    }, children || toLabel(item)));
  };

  return Segment;
}(React.Component);

_defineProperty(Segment, "defaultProps", {
  id: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  disabled: false,
  focused: false,
  children: undefined
});

export { Segment as default };